import $ from 'jquery';
import * as config from '../config/config';
import cokeStorage, { checkNested, request } from './utils';
class Auth {
  // 老接口：仅返回 CorpId，供 goLogin()（snsapi_base 静默授权）使用
  getCorpID() {
    this.appId = config.APPID;
    this.mpWorkAppId = config.MPWORKAPPID;
    const url = config.API.getcorpid(this.appId, this.mpWorkAppId);
    return new Promise((resolve, reject) => $.getJSON(url).then((res) => {
      if (checkNested(res, 'content', 'model')) {
        const cropid = res.content.model;
        cokeStorage.setItem('cropid', cropid);
        resolve(cropid);
      } else {
        reject();
      }
    }));
  }

  // 新接口：同时返回 CorpId + AgentId，供 goLoginPrivateInfo()（snsapi_privateinfo 授权）使用
  // snsapi_privateinfo 授权时 agentid 为必填参数，否则企业微信静默降级为 snsapi_base
  getCorpInfo() {
    this.appId = config.APPID;
    this.mpWorkAppId = config.MPWORKAPPID;
    const url = config.API.getcorpinfo(this.appId, this.mpWorkAppId);
    return new Promise((resolve, reject) => $.getJSON(url).then((res) => {
      if (checkNested(res, 'content', 'model', 'corpId')) {
        const cropid = res.content.model.corpId;
        const agentId = res.content.model.agentId;
        cokeStorage.setItem('cropid', cropid);
        cokeStorage.setItem('agentId', String(agentId));
        resolve({ cropid, agentId });
      } else {
        reject();
      }
    }));
  }

  getLocalAccessToken() {
    this.accesstoken = cokeStorage.getItem('access_token');
    return this.accesstoken;
  }

  getLocalUserRole() {
    this.role = cokeStorage.getItem('role');
    return this.role;
  }

  getLocalRefreshToken() {
    this.refreshtoken = cokeStorage.getItem('refresh_access_token');
    return this.refreshtoken;
  }

  setLocalAccessToken(model) {
    const { accessToken, refreshAccessToken, role, securityGuardPost, language } = model;
    this.accesstoken = accessToken;
    this.refreshAccessToken = refreshAccessToken;
    const currentTime = new Date();
    cokeStorage.setItem('currentTime', currentTime.getTime());
    cokeStorage.setItem('access_token', accessToken);
    cokeStorage.setItem('refresh_access_token', refreshAccessToken);
    cokeStorage.setItem('role', role);
    cokeStorage.setItem('securityGuardPost', securityGuardPost);
    localStorage.setItem('localeLanguage', language === 'en-US' ? 'en' : 'zh');
  }
  
  checkToken() {
    const currentTime = new Date();
    const getLocalStoryTime = cokeStorage.getItem('currentTime');
    if ((currentTime - getLocalStoryTime) > 30*60*1000) {
      return true;
    } else {
      return false;
    } 
  }

  getAccessToken(code) {
  this.code = code;
  const url = config.API.accesstoken;

  return new Promise((resolve, reject) => $.ajax({
    url,
    method: 'POST',
    contentType: 'application/json',
    data: JSON.stringify({ mpWorkAppId: config.MPWORKAPPID, code }),
    xhrFields: {
      withCredentials: true,
    },
  }).then((res) => {
    if (res.status === '004') {
      reject(res.message);
      return false;
    }

    // [新应用兼容] 2022-06-20 后新建应用首次登录时，后端检测到 user/get 未返回 email/mobile
    // 需要跳转 snsapi_privateinfo OAuth2 授权，让员工手工同意后企业微信才开放敏感字段
    if (res.status === '006') {
      // goLoginPrivateInfo 内部会触发页面跳转，跳转成功则页面卸载，Promise 自然失效
      // 跳转失败（getCorpID 异常）时 goLoginPrivateInfo 内部已记录 console.error
      this.goLoginPrivateInfo();
      reject('NeedOAuth2PrivateInfo');
      return false;
    }

    if (checkNested(res, 'content', 'model', 'accessToken')) {
      resolve(res.content.model);
    } else {
      reject(res.content.message);
    }

    return true;
  }));
}

  // snsapi_privateinfo 授权：需员工手工点击同意，企业微信才向应用开放 mobile/email 等敏感字段
  // 与 goLogin() 的区别：
  //   1. scope 改为 snsapi_privateinfo
  //   2. 必须携带 agentid（企业微信 2022-06-20 起强制要求，否则静默降级为 snsapi_base）
  //   3. redirect_uri 必须 encodeURIComponent，否则企业微信跳回时解析 URL 出错
  goLoginPrivateInfo() {
    this.getCorpInfo()
      .then(({ cropid, agentId }) => {
        // 必须清除当前 URL 中已有的 code/state，否则企业微信追加新 code 后会形成重复参数
        // Vue Router 对重复参数返回数组，数组转字符串时被逗号拼接（如 "BASE_CODE,PRIVATE_CODE"），
        // 导致后端收到无效 code，auth/getuserinfo 报 40029 invalid code
        const cleanUrl = new URL(window.location.href);
        cleanUrl.searchParams.delete('code');
        cleanUrl.searchParams.delete('state');
        const redirectUri = encodeURIComponent(cleanUrl.toString());
        // state 加 _private 后缀，router.js 凭此区分回调来自 snsapi_privateinfo，调用专用接口
        const state = `${config.MPWORKAPPID}_private`;
        const url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${cropid}&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_privateinfo&agentid=${agentId}&state=${state}#wechat_redirect`;
        window.location.href = url;
      })
      .catch(() => {
        console.error('[Auth] goLoginPrivateInfo: 获取企业应用信息失败，无法跳转 snsapi_privateinfo 授权页');
      });
  }

  // snsapi_privateinfo 手动授权专用：调用后端独立接口
  getAccessTokenPrivate(code) {
    const url = config.API.accesstokenPrivate(code);
    return new Promise((resolve, reject) => $.getJSON({
      url,
      xhrFields: { withCredentials: true },
    }).then((res) => {
      if (res.status === '004') {
        reject(res.message);
        return false;
      }
      if (checkNested(res, 'content', 'model', 'accessToken')) {
        resolve(res.content.model);
      } else {
        reject(res.content ? res.content.message : res.message);
      }
      return true;
    }));
  }

  getAccessTokenDebug(userid, isExternal) {
    this.userid = userid;

    let url;
    if (isExternal) {
      url = config.API.accesstokenLocalExternal(userid);
    } else {
      url = config.API.accesstokenLocal(userid);
    }

    return new Promise((resolve, reject) => $.getJSON({
      url,
      xhrFields: {
        withCredentials: true,
      },
    }).then((res) => {
      if (res.status === '004') {
        reject(res.message);
        return false;
      }

      if (checkNested(res, 'content', 'model', 'accessToken')) {
        resolve(res.content.model);
      } else {
        reject(res.content.message);
      }

      return true;
    }));
  }

  getRefreshAccessToken() {
    const t = this;
    this.mpWorkAppId = config.MPWORKAPPID;
    const url = config.API.refreshtoken;
    const token = this.getLocalAccessToken();
    const refreshtoken = this.getLocalRefreshToken();

    return new Promise((resolve, reject) => $.post({
      url,
      xhrFields: {
        withCredentials: true,
      },
      data: {
        MpworkAppId: config.MPWORKAPPID,
        Token: token,
        RefreshToken: refreshtoken,
      },
    }).then((res) => {
      if (res.content && res.content.status === 2) {
        t.goLogin();
        return false;
      }

      if (res.status === '004') {
        reject(res.message);
        return false;
      }

      if (checkNested(res, 'content', 'model', 'accessToken')) {
        resolve(res.content.model);
      } else {
        reject(res.content.message);
      }

      return true;
    }));
  }

  goLogin() {
    this.getCorpID()
      .then((cropid) => {
        const redirectUri = window.location.href;
        const url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${cropid}&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_base&state=${config.MPWORKAPPID}#wechat_redirect`;
        window.location.href = url;
      })
      .catch(() => {
        console.error('[Auth] goLogin: 获取企业应用信息失败，无法跳转 snsapi_base 授权页');
      });
  }

  isLogin() {
    return this.getLocalAccessToken();
  }

  getAccessTokenExternal(id, code) {
    return new Promise((resolve, reject) => {
      request({
        url: config.API.accessTokenExternal,
        method: 'post',
        data: {
          Id: id,
          Code: code,
        },
      }).then((res) => {
        const data = res.data;
        if (data.status === '004') {
          reject(data.message);
          return;
        }
        if (data.content && data.content.status === 2) {
          reject(data.content.message);
          return;
        }
        if (checkNested(data, 'content', 'model', 'accessToken')) {
          resolve(data.content.model);
        } else {
          reject(data.content.message);
        }
      }).catch(reject);
    });
  }

  getRefreshAccessTokenExternal() {
    const t = this;
    const url = config.API.refreshtokenExternal;
    const token = t.getLocalAccessToken();
    const refreshtoken = t.getLocalRefreshToken();

    return new Promise((resolve, reject) => $.post({
      url,
      xhrFields: {
        withCredentials: true,
      },
      data: {
        Token: token,
        RefreshToken: refreshtoken,
      },
    }).then((res) => {
      if (res.status === '004') {
        reject(res.message);
        return false;
      }

      if (res.content && res.content.status === 2) {
        reject(res.content.message);
        return false;
      }

      if (checkNested(res, 'content', 'model', 'accessToken')) {
        resolve(res.content.model);
      } else {
        reject(res.content.message);
        return false;
      }

      return true;
    }));
  }

  logoutExternal() {
    cokeStorage.removeItem('access_token');
    cokeStorage.removeItem('refresh_access_token');
    cokeStorage.removeItem('role');
    cokeStorage.removeItem('currentTime');
    window.location.href = window.location.origin + '/external/login';
  }
}

export default new Auth();
